import {UserStripeService} from "../../../stripe/service/UserStripeService";
import {StripeProductName} from "../../../stripe/models/StripeProductNames";
import {StripeUserSubscriptionRecord} from "../../../stripe/models/StripeUserSubscriptionRecord";
import {IHttpService} from "angular";
import {BundleProduct, StoreProductState, StoreProductStates} from "../../common/models/StoreProductState";
import {StoreService} from "../../common/services/StoreService";
import {IvProductMappings, IvStoreProduct} from "../models/IvStoreProduct";

export class IvStoreService extends StoreService<IvStoreProduct> {

    public static id = "ivStoreService";

    protected updateUrl = "/tradefloor/api/store/iv/subscriptions";

    /** @ngInject */
    public constructor($http: IHttpService, userStripeService: UserStripeService) {
        super($http, userStripeService);
    }

    public async currentProductState(): Promise<StoreProductStates<IvStoreProduct>> {
        const [history, subscriptions] = await this.userDetails();
        const platformHistory = history.historyFor(StripeProductName.PLATFORM);
        const hasPlatformSubscription = this.hasSubscriptionFor(subscriptions, IvProductMappings.PRO.stripeProducts);
        const backtestingHistory = history.historyFor(StripeProductName.BACKTESTING);
        const hasBacktestingSubscription = this.hasSubscriptionFor(subscriptions,
                                                                   IvProductMappings.BACKTESTING.stripeProducts);
        const alertingHistory = history.historyFor(StripeProductName.TRADING_SYSTEMS_ALERTS);
        const hasAlertingSubscription = this.hasSubscriptionFor(subscriptions,
                                                                IvProductMappings.TRADING_SYSTEMS.stripeProducts);
        const hasBundle = this.hasActiveBundleSubscription(subscriptions);
        if (hasBundle) {
            return this.bundleStates();
        }
        const pro = this.productState(hasPlatformSubscription, platformHistory);
        const backtesting = this.productState(hasBacktestingSubscription, backtestingHistory);
        const alerting = this.productState(hasAlertingSubscription, alertingHistory);
        const bundle = this.noHistoryProduct();
        return {
            PRO: pro,
            BACKTESTING: backtesting,
            TRADING_SYSTEMS: alerting,
            BUNDLE: bundle
        };
    }

    private hasActiveBundleSubscription(subscriptions: Array<StripeUserSubscriptionRecord>): boolean {
        const bundleProducts = IvProductMappings.BUNDLE.stripeProducts;
        return this.hasSubscriptionFor(subscriptions, bundleProducts);
    }

    private bundleStates(): StoreProductStates<IvStoreProduct> {
        const product = BundleProduct();
        const bundle: StoreProductState = {
            selected: true,
            locked: true,
            inBundle: false,
            hasTrialAvailable: false
        };
        return {
            PRO: product,
            TRADING_SYSTEMS: product,
            BACKTESTING: product,
            BUNDLE: bundle
        };
    }
}
